import initialState from './initial-state'
import * as types from './types'

export default {
    [types.ENTRAR] (state) {
        state.loading = true
        state.idToken = undefined
        state.accessToken = undefined
        state.expiresAt = undefined
    },
    [types.LOGADO] (state, payload) {
        const expires = new Date(new Date().getTime() + payload.expires_in * 1000)

        state.loading = false
        state.idToken = payload.id_token
        state.accessToken = payload.access_token
        state.expiresAt = expires
    },

    [types.SELECIONAR_TENANT] (state, payload) {
        state.tenant = payload
    },

    [types.LOGADO_FAIL] (state) {
        state.loading = false
        Object.assign(state, initialState)
    },

    [types.DESLOGADO] (state) {
        Object.assign(state, initialState)
    },

    [types.INDICAR_RETURN_URL] (state, payload) {
        state.returnUrl = payload
    },

    [types.INDICAR_CUPOM] (state, payload) {
        state.cupom = payload
    },

    [types.INDICAR_TRIAL] (state, payload) {
        state.cadastroState.trial = payload
    },

    [types.SET_PUBLIC_TOKEN] (state, payload) {
        state.publicToken = payload
    }
}